import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn, SignUp } from '@clerk/clerk-react';
import ForgotPassword from './ForgotPassword';
import Homepage from './Homepage';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';
import Pricing from './Pricing';
import About from './components/About';

// Protected route wrapper - redirects to sign-in if not logged in
function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <Navigate to="/sign-in" replace />
      </SignedOut>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/about" element={<About />} />

        {/* Auth routes */}
        <Route 
          path="/sign-in/*" 
          element={
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              minHeight: '100vh',
              background: '#f3f4f6'
            }}>
              <SignIn routing="path" path="/sign-in" afterSignInUrl="/dashboard" />
            </div>
          } 
        />
        <Route 
          path="/sign-up/*" 
          element={
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              minHeight: '100vh',
              background: '#f3f4f6'
            }}>
              <SignUp routing="path" path="/sign-up" afterSignUpUrl="/dashboard" />
            </div>
          } 
        />
        
        {/* Protected Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Protected Profile */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        {/* Redirect to Railway backend estimator */}
        <Route 
          path="/estimator" 
          element={
            <ProtectedRoute>
              <RedirectToEstimator />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

function RedirectToEstimator() {
  window.location.href = '/contractor-estimate-builder-v2.html';
  return <div>Redirecting to estimator...</div>;
}

export default App;